export default __webpack_public_path__ + "static/media/navigation-arrow.5d7b4db8.svg";